/**
 * Auth0 Configuration
 * 
 * Uses the same Auth0 app as the admin interface.
 * Required environment variables:
 * - VITE_AUTH0_DOMAIN: Auth0 tenant domain (e.g., your-tenant.us.auth0.com)
 * - VITE_AUTH0_CLIENT_ID: Auth0 application client ID
 * - VITE_AUTH0_AUDIENCE: Auth0 API audience/identifier
 * 
 * Note: Make sure to add your public site URLs to the Auth0 app's:
 * - Allowed Callback URLs
 * - Allowed Logout URLs
 * - Allowed Web Origins
 */

export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
  audience: import.meta.env.VITE_AUTH0_AUDIENCE || '',
};

/**
 * Check if Auth0 is configured
 */
export const isAuth0Configured = (): boolean => {
  return !!(auth0Config.domain && auth0Config.clientId);
};

/**
 * Feature flag to enable/disable the "Count Me In" participation feature.
 * Set VITE_FEATURE_COUNT_ME_IN=false in .env.local to disable.
 */
export const isCountMeInEnabled = (): boolean => {
  return import.meta.env.VITE_FEATURE_COUNT_ME_IN !== 'false';
};
